import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { Alert, Button, Skeleton, Typography } from '@mui/material';
import { IMaintenance } from 'features/inventory/maintenance';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import { maintenanceService } from 'shared/services';

function ExpiringMaintenancesWidget() {
  const { t } = useTranslation();
  const [maintenances, setMaintenances] = useState<IMaintenance[]>();
  useEffect(() => {
    maintenanceService.getExpiringMaintenances(3, 0).then((res) => setMaintenances(res.results));
  }, []);

  return (
    <div>
      <Typography sx={{ fontSize: 14 }} color="secondary" gutterBottom>
        <ManageAccountsIcon />
        {t('dashboard.expiration-maintenances.title')}
      </Typography>
      {!maintenances && (
        <>
          <Skeleton variant="rectangular" height={32} />
          <br />
          <Skeleton variant="rectangular" height={32} />
          <br />
          <Skeleton variant="rectangular" height={32} />
        </>
      )}
      {maintenances && maintenances.length === 0 && (
        <Alert severity="success" variant="outlined">
          {t('dashboard.expiration-maintenances.empty', {
            defaultValue: 'Nessuna manutenzione in scadenza'
          })}
        </Alert>
      )}
      {maintenances &&
        maintenances.map((maintenance) => (
          <Alert
            severity={'warning'}
            key={maintenance.id}
            className="mb-2"
            action={
              <NavLink
                to={`/tenant/equipments/maintenance?equipment_id=${maintenance.equipment_id}`}>
                <Button color="inherit" size="small">
                  {t('dashboard.expiration-maintenances.go')}
                </Button>
              </NavLink>
            }>
            {t('dashboard.expiration-maintenances.row-body', {
              code: maintenance.equipment,
              serial_number: maintenance.serial_number,
              date: maintenance.expected_date
            })}
          </Alert>
        ))}
    </div>
  );
}

export default ExpiringMaintenancesWidget;
